import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const Birthday3 = () => {
    const navigate = useNavigate();
    const audioRef = useRef(null);
    const waveformRef = useRef(null);

    // Doğum günü tarihi - 25 Ağustos 2025 Pazartesi
    const [birthdayDate] = useState(new Date('2025-08-25T20:00:00'));

    // Geri sayım için state
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });

    const [currentTrack, setCurrentTrack] = useState(0);
    const [isPlaying, setIsPlaying] = useState(false);
    const [showMemories, setShowMemories] = useState(false);
    const [selectedMemory, setSelectedMemory] = useState(null);
    const [audioWaveform, setAudioWaveform] = useState([]);

    // 80'ler hit listesi
    const tracks = [
        { title: "Take On Me", artist: "a-ha", year: "1985", genre: "Synth-pop" },
        { title: "Sweet Child O' Mine", artist: "Guns N' Roses", year: "1987", genre: "Rock" },
        { title: "Livin' on a Prayer", artist: "Bon Jovi", year: "1986", genre: "Rock" },
        { title: "Tainted Love", artist: "Soft Cell", year: "1981", genre: "New Wave" },
        { title: "Blue Monday", artist: "New Order", year: "1983", genre: "Electronic" }
    ];

    // Anı kartları
    const memories = [
        {
            id: 1,
            title: "İlk Konser Anım",
            year: "2019",
            description: "Metallica konserinde çılgın geçen gece",
            mood: "🤘",
            color: "from-orange-400 to-red-500"
        },
        {
            id: 2,
            title: "Mezuniyet Coşkusu",
            year: "2022",
            description: "Üniversite bitirme sevinci",
            mood: "🎓",
            color: "from-blue-400 to-purple-500"
        },
        {
            id: 3,
            title: "Arkadaşlarla Roadtrip",
            year: "2023",
            description: "Karadeniz turunda unutulmaz anlar",
            mood: "🚗",
            color: "from-green-400 to-teal-500"
        },
        {
            id: 4,
            title: "İlk İş Günü",
            year: "2023",
            description: "Kariyere ilk adım heyecanı",
            mood: "💼",
            color: "from-gray-400 to-slate-500"
        },
        {
            id: 5,
            title: "24. Yaş Sürprizi",
            year: "2024",
            description: "Arkadaşların hazırladığı sürpriz parti",
            mood: "🎉",
            color: "from-pink-400 to-rose-500"
        },
        {
            id: 6,
            title: "Yeni Hobim",
            year: "2024",
            description: "Gitar çalmaya başladığım günler",
            mood: "🎸",
            color: "from-amber-400 to-yellow-500"
        }
    ];

    // Waveform animasyonu
    useEffect(() => {
        const bars = Array.from({ length: 40 }, () => Math.random() * 100);
        setAudioWaveform(bars);

        if (isPlaying) {
            const interval = setInterval(() => {
                setAudioWaveform(prev => prev.map(() => Math.random() * 100));
            }, 150);
            return () => clearInterval(interval);
        }
    }, [isPlaying]);

    // Geri sayım timer'ı
    useEffect(() => {
        const timer = setInterval(() => {
            const now = new Date().getTime();
            const distance = birthdayDate.getTime() - now;

            if (distance > 0) {
                const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((distance % (1000 * 60)) / 1000);

                setTimeLeft({ days, hours, minutes, seconds });
            } else {
                setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [birthdayDate]);

    const playPause = () => {
        setIsPlaying(!isPlaying);
    };

    const nextTrack = () => {
        setCurrentTrack((prev) => (prev + 1) % tracks.length);
    };

    const prevTrack = () => {
        setCurrentTrack((prev) => (prev - 1 + tracks.length) % tracks.length);
    };

    const openMemory = (memory) => {
        setSelectedMemory(memory);
    };

    const closeMemory = () => {
        setSelectedMemory(null);
    };

    return (
        <div className="min-h-screen relative overflow-hidden bg-gradient-to-br from-slate-900 via-purple-900 to-slate-800">
            {/* Animated Background Elements */}
            <div className="absolute inset-0">
                {/* Geometric patterns */}
                <div className="absolute top-10 left-10 w-32 h-32 border border-cyan-400/20 rotate-45 animate-spin-slow"></div>
                <div className="absolute top-32 right-20 w-24 h-24 border border-pink-400/20 rotate-12 animate-pulse"></div>
                <div className="absolute bottom-20 left-20 w-40 h-40 border border-yellow-400/20 rotate-45 animate-bounce-slow"></div>

                {/* Floating elements */}
                {[...Array(8)].map((_, i) => (
                    <div
                        key={i}
                        className="absolute opacity-10 animate-float"
                        style={{
                            left: `${Math.random() * 100}%`,
                            top: `${Math.random() * 100}%`,
                            animationDelay: `${i * 0.5}s`,
                            animationDuration: `${4 + Math.random() * 2}s`
                        }}
                    >
                        <div className="w-2 h-2 bg-gradient-to-r from-cyan-400 to-pink-400 rounded-full"></div>
                    </div>
                ))}
            </div>

            {/* Geri Dön Butonu */}
            <button
                onClick={() => navigate('/calismalarimiz')}
                className="fixed top-6 left-6 z-50 bg-white/10 backdrop-blur-md hover:bg-white/20 text-white p-3 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 border border-white/20"
                aria-label="Çalışmalarımıza Geri Dön"
            >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
            </button>

            {/* Ana Container */}
            <div className="relative z-10 min-h-screen flex flex-col items-center justify-start pt-16 px-4">

                {/* Header */}
                <div className="text-center mb-16 animate-fade-in-up">
                    <div className="mb-8">
                        <div className="inline-block relative">
                            <h1 className="text-6xl md:text-8xl font-black bg-gradient-to-r from-cyan-400 via-pink-400 to-yellow-400 bg-clip-text text-transparent mb-4 leading-tight">
                                AHMET
                            </h1>
                            <div className="absolute -top-2 -right-2 w-8 h-8 bg-gradient-to-r from-pink-500 to-cyan-500 rounded-full animate-pulse"></div>
                        </div>

                        <div className="flex items-center justify-center gap-6 mb-6">
                            <div className="age-badge">
                                <span className="text-4xl font-black">25</span>
                            </div>
                            <div className="text-2xl font-light text-white/80">yaşında!</div>
                        </div>

                        <div className="bg-gradient-to-r from-pink-500/20 to-cyan-500/20 backdrop-blur-sm border border-white/20 rounded-full px-6 py-3 inline-block">
                            <span className="text-white font-medium">🎵 80's Vibes Party 🎵</span>
                        </div>
                    </div>
                </div>

                {/* Countdown */}
                <div className="mb-16 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
                    <h3 className="text-center text-white/90 text-xl font-medium mb-8">
                        Partiye Kalan Süre
                    </h3>
                    <div className="grid grid-cols-4 gap-4 max-w-lg mx-auto">
                        {[
                            { value: timeLeft.days, label: 'Gün' },
                            { value: timeLeft.hours, label: 'Saat' },
                            { value: timeLeft.minutes, label: 'Dakika' },
                            { value: timeLeft.seconds, label: 'Saniye' }
                        ].map((item, index) => (
                            <div key={index} className="countdown-card">
                                <div className="text-3xl font-black text-white mb-1">
                                    {String(item.value).padStart(2, '0')}
                                </div>
                                <div className="text-xs text-white/70 uppercase tracking-wider">
                                    {item.label}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Music Player */}
                <div className="mb-16 animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
                    <div className="music-player">
                        <div className="player-header">
                            <div className="flex items-center gap-3">
                                <div className="w-8 h-8 bg-gradient-to-r from-pink-500 to-cyan-500 rounded-lg flex items-center justify-center">
                                    <span className="text-white text-sm font-bold">♪</span>
                                </div>
                                <span className="text-white font-semibold">Ahmet'in 80's Mix</span>
                            </div>
                            <div className="text-white/60 text-sm">
                                {currentTrack + 1} / {tracks.length}
                            </div>
                        </div>

                        <div className="player-display">
                            <div className="track-info">
                                <div className="text-white font-bold text-lg mb-1">
                                    {tracks[currentTrack].title}
                                </div>
                                <div className="text-white/70 text-sm mb-2">
                                    {tracks[currentTrack].artist} • {tracks[currentTrack].year}
                                </div>
                                <div className="text-xs text-cyan-400 bg-cyan-400/20 px-2 py-1 rounded-full inline-block">
                                    {tracks[currentTrack].genre}
                                </div>
                            </div>

                            {/* Waveform Visualizer */}
                            <div className="waveform">
                                {audioWaveform.map((height, index) => (
                                    <div
                                        key={index}
                                        className="waveform-bar"
                                        style={{
                                            height: `${height}%`,
                                            animationDelay: `${index * 0.05}s`
                                        }}
                                    ></div>
                                ))}
                            </div>
                        </div>

                        <div className="player-controls">
                            <button onClick={prevTrack} className="control-btn control-btn-secondary">
                                ⏮
                            </button>
                            <button onClick={playPause} className="control-btn control-btn-primary">
                                {isPlaying ? '⏸' : '▶'}
                            </button>
                            <button onClick={nextTrack} className="control-btn control-btn-secondary">
                                ⏭
                            </button>
                        </div>
                    </div>
                </div>

                {/* Event Details */}
                <div className="mb-16 w-full max-w-2xl animate-fade-in-up" style={{ animationDelay: '0.6s' }}>
                    <div className="event-card">
                        <div className="event-header">
                            <h3 className="text-2xl font-bold text-white mb-2">Party Details</h3>
                            <div className="w-12 h-1 bg-gradient-to-r from-pink-500 to-cyan-500 rounded-full"></div>
                        </div>

                        <div className="event-content">
                            <div className="event-item">
                                <div className="event-icon">📅</div>
                                <div>
                                    <div className="event-label">Tarih</div>
                                    <div className="event-value">25 Ağustos 2025, Pazartesi</div>
                                </div>
                            </div>

                            <div className="event-item">
                                <div className="event-icon">⏰</div>
                                <div>
                                    <div className="event-label">Saat</div>
                                    <div className="event-value">20:00 - 02:00</div>
                                </div>
                            </div>

                            <div className="event-item">
                                <div className="event-icon">📍</div>
                                <div>
                                    <div className="event-label">Mekan</div>
                                    <div className="event-value">The Retrograde Club</div>
                                    <div className="event-subtitle">Kadıköy, İstanbul</div>
                                </div>
                            </div>

                            <div className="event-item special">
                                <div className="event-icon">👕</div>
                                <div>
                                    <div className="event-label">Dress Code</div>
                                    <div className="event-value text-gradient">80's Retro Style</div>
                                    <div className="event-subtitle">Neon colors encouraged!</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Memories Section */}
                <div className="mb-16 animate-fade-in-up" style={{ animationDelay: '0.8s' }}>
                    <button
                        onClick={() => setShowMemories(!showMemories)}
                        className="memories-toggle-btn mb-8"
                    >
                        <span className="text-lg">📸</span>
                        <span>{showMemories ? 'Anıları Gizle' : '25 Yıllık Anılar'}</span>
                        <span className={`transform transition-transform ${showMemories ? 'rotate-180' : ''}`}>
                            ↓
                        </span>
                    </button>

                    {showMemories && (
                        <div className="memories-grid">
                            {memories.map((memory, index) => (
                                <div
                                    key={memory.id}
                                    className="memory-card"
                                    style={{ animationDelay: `${index * 0.1}s` }}
                                    onClick={() => openMemory(memory)}
                                >
                                    <div className={`memory-bg bg-gradient-to-br ${memory.color}`}></div>
                                    <div className="memory-content">
                                        <div className="memory-mood">{memory.mood}</div>
                                        <div className="memory-year">{memory.year}</div>
                                        <div className="memory-title">{memory.title}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-4 mb-16 animate-fade-in-up" style={{ animationDelay: '1s' }}>
                    <a
                        href="https://www.google.com/maps/dir/?api=1&destination=The+Retrograde+Club,Kadıköy,İstanbul"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="action-btn action-btn-primary"
                    >
                        <span>🗺️</span>
                        <span>Konumu Gör</span>
                    </a>
                    <button className="action-btn action-btn-secondary">
                        <span>📱</span>
                        <span>Katılacağım</span>
                    </button>
                </div>

                {/* Footer */}
                <div className="text-center mb-8 animate-fade-in-up" style={{ animationDelay: '1.2s' }}>
                    <div className="text-white/80 text-lg font-medium mb-2">
                        Let's make some new memories! ✨
                    </div>
                    <div className="text-white/50 text-sm">
                        with love, DigiVite • 2025
                    </div>
                </div>
            </div>

            {/* Memory Modal */}
            {selectedMemory && (
                <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
                    <div className="memory-modal">
                        <button
                            onClick={closeMemory}
                            className="modal-close-btn"
                        >
                            ✕
                        </button>
                        <div className={`modal-bg bg-gradient-to-br ${selectedMemory.color}`}></div>
                        <div className="modal-content">
                            <div className="modal-mood">{selectedMemory.mood}</div>
                            <div className="modal-year">{selectedMemory.year}</div>
                            <div className="modal-title">{selectedMemory.title}</div>
                            <div className="modal-description">{selectedMemory.description}</div>
                        </div>
                    </div>
                </div>
            )}

            {/* Custom Styles */}
            <style jsx>{`
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
                
                * {
                    font-family: 'Inter', sans-serif;
                }

                @keyframes fade-in-up {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @keyframes float {
                    0%, 100% { transform: translateY(0px); }
                    50% { transform: translateY(-20px); }
                }

                @keyframes spin-slow {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }

                @keyframes bounce-slow {
                    0%, 100% { transform: translateY(0px); }
                    50% { transform: translateY(-10px); }
                }

                .animate-fade-in-up {
                    animation: fade-in-up 0.8s ease-out forwards;
                }

                .animate-float {
                    animation: float infinite ease-in-out;
                }

                .animate-spin-slow {
                    animation: spin-slow 20s linear infinite;
                }

                .animate-bounce-slow {
                    animation: bounce-slow 3s ease-in-out infinite;
                }

                .age-badge {
                    background: linear-gradient(135deg, #ff006e, #8338ec, #3a86ff);
                    border-radius: 20px;
                    padding: 12px 20px;
                    border: 2px solid rgba(255, 255, 255, 0.2);
                    backdrop-filter: blur(10px);
                    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
                    color: white;
                }

                .countdown-card {
                    background: rgba(255, 255, 255, 0.1);
                    backdrop-filter: blur(10px);
                    border: 1px solid rgba(255, 255, 255, 0.2);
                    border-radius: 16px;
                    padding: 20px;
                    text-align: center;
                    transition: all 0.3s ease;
                }

                .countdown-card:hover {
                    background: rgba(255, 255, 255, 0.15);
                    transform: translateY(-2px);
                }

                .music-player {
                    background: rgba(0, 0, 0, 0.4);
                    backdrop-filter: blur(20px);
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    border-radius: 20px;
                    padding: 24px;
                    width: 100%;
                    max-width: 400px;
                    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
                }

                .player-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 20px;
                    padding-bottom: 16px;
                    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
                }

                .player-display {
                    margin-bottom: 20px;
                }

                .track-info {
                    margin-bottom: 16px;
                }

                .waveform {
                    display: flex;
                    align-items: end;
                    gap: 2px;
                    height: 40px;
                    margin-bottom: 16px;
                }

                .waveform-bar {
                    background: linear-gradient(to top, #ff006e, #8338ec, #3a86ff);
                    width: 3px;
                    border-radius: 2px;
                    transition: height 0.1s ease;
                    opacity: ${isPlaying ? '1' : '0.3'};
                }

                .player-controls {
                    display: flex;
                    justify-content: center;
                    gap: 16px;
                }

                .control-btn {
                    width: 48px;
                    height: 48px;
                    border-radius: 12px;
                    border: none;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 16px;
                    transition: all 0.3s ease;
                }

                .control-btn-primary {
                    background: linear-gradient(135deg, #ff006e, #8338ec);
                    color: white;
                    box-shadow: 0 4px 15px rgba(255, 0, 110, 0.3);
                }

                .control-btn-primary:hover {
                    transform: scale(1.05);
                    box-shadow: 0 6px 20px rgba(255, 0, 110, 0.4);
                }

                .control-btn-secondary {
                    background: rgba(255, 255, 255, 0.1);
                    color: white;
                    border: 1px solid rgba(255, 255, 255, 0.2);
                }

                .control-btn-secondary:hover {
                    background: rgba(255, 255, 255, 0.2);
                    transform: scale(1.05);
                }

                .event-card {
                    background: rgba(255, 255, 255, 0.05);
                    backdrop-filter: blur(20px);
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    border-radius: 20px;
                    padding: 32px;
                    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
                }

                .event-header {
                    margin-bottom: 24px;
                }

                .event-content {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                }

                .event-item {
                    display: flex;
                    align-items: flex-start;
                    gap: 16px;
                    padding: 16px;
                    border-radius: 12px;
                    background: rgba(255, 255, 255, 0.05);
                    transition: all 0.3s ease;
                }

                .event-item:hover {
                    background: rgba(255, 255, 255, 0.1);
                    transform: translateX(4px);
                }

                .event-item.special {
                    background: linear-gradient(135deg, rgba(255, 0, 110, 0.1), rgba(131, 56, 236, 0.1));
                    border: 1px solid rgba(255, 0, 110, 0.2);
                }

                .event-icon {
                    font-size: 24px;
                    width: 40px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: rgba(255, 255, 255, 0.1);
                    border-radius: 10px;
                    flex-shrink: 0;
                }

                .event-label {
                    color: rgba(255, 255, 255, 0.7);
                    font-size: 14px;
                    font-weight: 500;
                    margin-bottom: 4px;
                }

                .event-value {
                    color: white;
                    font-size: 16px;
                    font-weight: 600;
                }

                .event-subtitle {
                    color: rgba(255, 255, 255, 0.6);
                    font-size: 14px;
                    margin-top: 2px;
                }

                .text-gradient {
                    background: linear-gradient(135deg, #ff006e, #8338ec, #3a86ff);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                }

                .memories-toggle-btn {
                    background: linear-gradient(135deg, rgba(255, 0, 110, 0.2), rgba(131, 56, 236, 0.2));
                    border: 1px solid rgba(255, 255, 255, 0.2);
                    color: white;
                    padding: 16px 24px;
                    border-radius: 16px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    font-weight: 600;
                    transition: all 0.3s ease;
                }

                .memories-toggle-btn:hover {
                    background: linear-gradient(135deg, rgba(255, 0, 110, 0.3), rgba(131, 56, 236, 0.3));
                    transform: scale(1.02);
                }

                .memories-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                    gap: 20px;
                    max-width: 800px;
                    margin: 0 auto;
                }

                .memory-card {
                    position: relative;
                    height: 160px;
                    border-radius: 16px;
                    overflow: hidden;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    animation: fade-in-up 0.6s ease-out forwards;
                    opacity: 0;
                }

                .memory-card:hover {
                    transform: translateY(-8px) scale(1.02);
                    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
                }

                .memory-bg {
                    position: absolute;
                    inset: 0;
                    opacity: 0.8;
                }

                .memory-content {
                    position: relative;
                    height: 100%;
                    padding: 20px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.3));
                }

                .memory-mood {
                    font-size: 24px;
                    align-self: flex-start;
                }

                .memory-year {
                    color: rgba(255, 255, 255, 0.8);
                    font-size: 12px;
                    font-weight: 600;
                    margin-bottom: 4px;
                }

                .memory-title {
                    color: white;
                    font-size: 16px;
                    font-weight: 700;
                    line-height: 1.2;
                }

                .action-btn {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    padding: 16px 24px;
                    border-radius: 16px;
                    font-weight: 600;
                    text-decoration: none;
                    transition: all 0.3s ease;
                    border: none;
                    cursor: pointer;
                }

                .action-btn-primary {
                    background: linear-gradient(135deg, #3a86ff, #06ffa5);
                    color: white;
                    box-shadow: 0 8px 25px rgba(58, 134, 255, 0.3);
                }

                .action-btn-primary:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 12px 35px rgba(58, 134, 255, 0.4);
                }

                .action-btn-secondary {
                    background: rgba(255, 255, 255, 0.1);
                    color: white;
                    border: 1px solid rgba(255, 255, 255, 0.2);
                }

                .action-btn-secondary:hover {
                    background: rgba(255, 255, 255, 0.2);
                    transform: translateY(-2px);
                }

                .memory-modal {
                    position: relative;
                    width: 90vw;
                    max-width: 400px;
                    height: 300px;
                    border-radius: 20px;
                    overflow: hidden;
                    animation: fade-in-up 0.3s ease-out;
                }

                .modal-close-btn {
                    position: absolute;
                    top: 16px;
                    right: 16px;
                    width: 32px;
                    height: 32px;
                    background: rgba(0, 0, 0, 0.5);
                    color: white;
                    border: none;
                    border-radius: 8px;
                    cursor: pointer;
                    z-index: 10;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: bold;
                    transition: all 0.2s ease;
                }

                .modal-close-btn:hover {
                    background: rgba(0, 0, 0, 0.7);
                }

                .modal-bg {
                    position: absolute;
                    inset: 0;
                }

                .modal-content {
                    position: relative;
                    height: 100%;
                    padding: 32px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.4));
                }

                .modal-mood {
                    font-size: 32px;
                    align-self: flex-start;
                }

                .modal-year {
                    color: rgba(255, 255, 255, 0.9);
                    font-size: 14px;
                    font-weight: 600;
                    margin-bottom: 8px;
                }

                .modal-title {
                    color: white;
                    font-size: 24px;
                    font-weight: 800;
                    margin-bottom: 8px;
                    line-height: 1.2;
                }

                .modal-description {
                    color: rgba(255, 255, 255, 0.9);
                    font-size: 16px;
                    line-height: 1.4;
                }

                /* Responsive */
                @media (max-width: 768px) {
                    .music-player {
                        max-width: 320px;
                    }
                    
                    .memories-grid {
                        grid-template-columns: repeat(2, 1fr);
                    }
                    
                    .event-card {
                        padding: 24px;
                    }
                }
            `}</style>
        </div>
    );
};

export default Birthday3; 